// import { SCREENER_CHAINS } from "@constants/screener-chains";
import clsx from "clsx";
import { Link, useLocation } from "react-router";

const navigationItems = [
  { title: "Portfolio", href: "/portfolio", enabled: true },
  // {
  //   title: "Orders",
  //   href: "/orders",
  //   enabled: true,
  // },
  // {
  //   title: "Algo Trade",
  //   href: "/algo-trade",
  //   enabled: false,
  // },
  {
    title: "Find Tokens",
    href: `/screener`,
    enabled: true,
  },
  { title: "Copy Trade", href: "/copy-trade", enabled: true },
  { title: "Algo Trade", href: "/copy-trade", enabled: false },
  // {
  //   title: "Wallet Discovery",
  //   href: "/wallet-screener",
  //   enabled: true,
  // },
  // {
  //   title: "X Sentiments",
  //   href: "/x-sentiments",
  //   enabled: false,
  // },
  // {
  //   title: "Revenue Share",
  //   href: "/revenue-share",
  //   enabled: false,
  // },
  // {
  //   title: "Hall of Fame",
  //   href: "/hall-of-fame",
  //   enabled: false,
  // },
  // {
  //   title: "T&C's",
  //   href: "/legal",
  //   enabled: true,
  //   links: [
  //     { title: "Terms of Service", href: "/legal/terms-of-service" },
  //     { title: "Privacy Policy", href: "/legal/privacy-policy" },
  //   ],
  // },
];

const NavigationItems = () => {
  const { pathname } = useLocation();
  const pathnameWithoutSlash = `/${pathname.split("/").at(1)}`;

  return navigationItems.map(({ title, href, enabled }) => {
    if (enabled) {
      return (
        <Link
          key={href}
          to={href}
          className={clsx(
            "h-full px-[0.625rem] flex items-center rounded-3xl text-white font-semibold text-xs leading-[1.1250rem] hover:text-opacity-100",
            pathnameWithoutSlash === href
              ? "text-opacity-100"
              : "text-opacity-50"
          )}
        >
          {title}
        </Link>
      );
    }

    return (
      <div
        key={href}
        className="h-full px-[0.625rem] cursor-not-allowed flex items-center rounded-3xl text-white text-opacity-50 font-semibold text-xs leading-[1.1250rem]"
      >
        {title}
      </div>
    );
  });
};

export default NavigationItems;
